import "../node_modules/@fontsource/golos-text/600.css";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./redux-store/store";
import { HashRouter } from "react-router-dom";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <HashRouter basename={"/"}>
    <Provider store={store}>
      <App/>
    </Provider>
  </HashRouter>
);





